/** A safe (for server-side rendering) event handler that scrolls to the top of the page */
export default () => (typeof window !== 'undefined' ? window.scrollTo(0, 0) : undefined)



// WEBPACK FOOTER //
// ./src/common/ui/scrollToTop.js